<div class="task-filters">
  <mat-form-field *ngIf="showStatus" class="task-filter-field task-filter-select" appearance="fill">
    <mat-label>Status</mat-label>
    <mat-select multiple [ngModel]="statusFilter" (ngModelChange)="onStatusSelectionChange($event)">
      <mat-select-trigger>{{ statusFilterLabel }}</mat-select-trigger>
      <mat-option *ngFor="let option of statusOptions" [value]="option.value">{{ option.displayName }}</mat-option>
    </mat-select>
  </mat-form-field>
  
  <mat-form-field *ngIf="showAccount" class="task-filter-field task-filter-select" appearance="fill">
    <mat-label>Account</mat-label>
    <mat-select multiple panelClass="account-filter-panel" [ngModel]="accountFilter" (ngModelChange)="onAccountSelectionChange($event)">
      <mat-select-trigger>{{ accountFilterLabel }}</mat-select-trigger>
      <mat-option *ngFor="let option of accountOptions" [value]="option.value">{{ option.displayName }}</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field *ngFor="let range of dateRanges" class="task-filter-field" appearance="fill">
    <mat-label>{{ range.label }}</mat-label>
    <mat-date-range-input [rangePicker]="picker">
      <input matStartDate placeholder="Start date" [(ngModel)]="rangeValues[range.key].start" (dateChange)="onRangeChange()">
      <input matEndDate placeholder="End date" [(ngModel)]="rangeValues[range.key].end" (dateChange)="onRangeChange()">
    </mat-date-range-input>
    <mat-datepicker-toggle matIconSuffix [for]="picker">
      <mat-icon matDatepickerToggleIcon>arrow_drop_down</mat-icon>
    </mat-datepicker-toggle>
    <mat-date-range-picker #picker></mat-date-range-picker>
  </mat-form-field>

  <button
    *ngIf="activeFilterCount > 0"
    type="button"
    class="clear-filters-link"
    (click)="clear()">
    CLEAR
  </button>

  <div *ngIf="showSearch" class="filterSearch">
    <mat-form-field class="case-search-input" floatLabel="never" appearance="fill">
      <input
        class="case-summary-search-input"
        matInput
        placeholder="Search"
        name="filterValue"
        [ngModel]="searchTerm"
        (ngModelChange)="onSearchChange($event)"
      >
      <span matTextPrefix>
        <mat-icon>search</mat-icon>
      </span>
    </mat-form-field>
  </div>
</div>
